import type { NewsletterConfig } from './types.js';

export const EXPIRY_PERIOD_24HOURS: number = 3600000 * 24;
export const EXPIRY_PERIOD_5MINUTES = 300000;
export const NEWSLETTERS_HOME_URL =
  'https://kundeportal.aftenposten.no/nyhetsbrev';
export const SUBSCRIBE_TO_AP_URL =
  'https://kundeportal.aftenposten.no/s/bliabonnent?referer=AP-u-u_nyhetsbrevportal_nocampaign';

export const NEWSLETTER_VINK = '5b77d4c2-15b6-489d-8984-c360183c5aea';
export const NEWSLETTER_SERIETIPS = 'f0236311-568e-49ce-bc7f-07eca9485e43';

export const newsletterMappings: Record<string, NewsletterConfig> = {
  '5b77d4c2-15b6-489d-8984-c360183c5aea': {
    title: 'Vink til helgen',
    access: 'open',
    description: 'Ja! Send meg de beste Oslo-tipsene hver helg',
  },
  'f0236311-568e-49ce-bc7f-07eca9485e43': {
    title: 'Serietips',
    access: 'open',
    description: 'Få tips om serier og filmer rett i innboksen',
  },
};
